import React from 'react'
import Button from 'lib/ui/Button'
import {uuid} from 'lib/uuid'
import styled from 'styled-components'
import {createPositions, orderedIdsByPosition} from 'lib/list'
import Icon from 'lib/ui/Icon'
import {createSection} from 'Event/Marketplace/create-section'
import {PurchasePageTemplate} from 'Event/Marketplace/purchase-page'
import {ThankYouPageTemplate} from 'Event/Marketplace/thank-you-page'
import {UpsellPageTemplate} from 'Event/Marketplace/upsell-page'
import {JsonSave} from 'lib/JsonUpdateProvider'
import {PageTemplate} from 'Event/Marketplace/page-template'

export default function AddSectionButton(props: {
  template: PageTemplate
  updateTemplate: JsonSave<
    PurchasePageTemplate | ThankYouPageTemplate | UpsellPageTemplate
  >
}) {
  const {template, updateTemplate} = props
  const addSection = () => {
    const ids = orderedIdsByPosition(template.sections)

    const sections = createPositions(ids)

    const id = uuid()
    updateTemplate({
      sections: {
        ...sections,
        [id]: createSection(),
      },
    })
  }

  return (
    <Box>
      <StyledButton
        variant="contained"
        fullWidth
        onClick={addSection}
        size="large"
        startIcon={<Icon className="fa-solid fa-circle-plus" />}
      >
        Add Section
      </StyledButton>
    </Box>
  )
}

const Box = styled.div`
  margin: 3rem 0;
  padding: ${(props) => `${props.theme.spacing[6]} ${props.theme.spacing[3]}`};
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledButton = styled(Button)`
  max-width: 300px;
  color: white;
  background-color: #1e4686;
  &:hover {
    background-color: #1e4686;
    opacity: 0.9;
  }
`
